import Home from ".";

export const homeRoutes = () => [
  {
    path: "/",
    component: Home,
    layout: "front",
    title: "page",
  },
];